// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nk-0";
export var assigneeDetails = "_nk-1";
export var assigneeInfo = "_nk-2";
export var dropdownContainer = "_nk-4";
export var dropdownImage = "_nk-5";
export var editAssigneeInfo = "_nk-3";
export var editAssigneeModalContainer = "_nk-6";
export var hidden = "_nk-8";
export var input = "_nk-7";